"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.aiFormAnalyzer.name': 'Analizador de formularios con IA',
    'tools.aiFormAnalyzer.formSentByUser': 'He enviado el formulario.',
};
